import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TrackedItem {
  id: string;
  name: string;
  price: number;
  timestamp: string;
}

interface TrackingState {
  trackedItems: TrackedItem[];
}

const initialState: TrackingState = {
  trackedItems: [],
};

const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    addTrackedItem: (state, action: PayloadAction<TrackedItem>) => {
      if (!state.trackedItems.some((item) => item.id === action.payload.id)) {
        state.trackedItems.push(action.payload);
      }
    },
    removeTrackedItem: (state, action: PayloadAction<string>) => {
      state.trackedItems = state.trackedItems.filter((item) => item.id !== action.payload);
    },
    clearTrackedItems: (state) => {
      state.trackedItems = [];
    },
  },
});

export const { addTrackedItem, removeTrackedItem, clearTrackedItems } = trackingSlice.actions;
export default trackingSlice.reducer;
